import { render, staticRenderFns } from "./DeleteConfirmAllQuestions.vue?vue&type=template&id=497493c9"
import script from "./DeleteConfirmAllQuestions.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmAllQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports